export function formatArticle(article) {
  if (!article) {
    return {};
  }
  // Prep article object
  const articleObj = {
    title: article.title || "",
    description: article.content || "",
    slug: article.slug,
    categories: article.categories?.nodes || [],
    image: article.post_fields_article?.image?.sourceUrl || "",
    fluidImage:
      article.post_fields_article?.image.localFile?.childImageSharp?.fluid ||
      "",
    gatsbyImageData:
      article.post_fields_article?.image?.localFile?.childImageSharp
        .gatsbyImageData || "",
    fixedImage:
      article.post_fields_article?.image.localFile?.childImageSharp?.fixed ||
      "",
    altText: article.post_fields_article?.image?.altText || "",
    author: article.post_fields_article?.authorName || "",
    authorTitle: article.post_fields_article?.authorTitle || "",
    authorPlaceOfWork: article.post_fields_article?.authorPlaceOfWork || "",
    authorLink: article.post_fields_article?.authorLink || "",
    authorAvatar: article.post_fields_article?.authorAvatar?.sourceUrl || "",
    authorAvatarAltText:
      article.post_fields_article?.authorAvatar?.altText || "",
    illustrator: article.post_fields_article?.illustratorName || "",
    illustratorTitle: article.post_fields_article?.illustratorTitle || "",
    illustratorPlaceOfWork:
      article.post_fields_article?.illustratorPlaceOfWork || "",
    illustratorLink: article.post_fields_article?.illustratorLink || "",
    illustratorAvatar:
      article.post_fields_article?.illustratorAvatar?.sourceUrl || "",
    illustratorAvatarAltText:
      article.post_fields_article?.illustratorAvatar?.altText || "",
    contributorList: article.post_fields_article?.contributorGroup || [],
    link: article.post_fields_article?.externalLink || "",
    articleContent: article.post_fields_article?.articleContent || "",
    publishDate: article.post_fields_article?.articlePublishDate || "",
    excerpt: article.excerpt || "",
    mediaType: article.post_fields_article?.mediaType || "",
    animationUrl: article.post_fields_article?.animationUrl?.mediaItemUrl || "",
  };

  return articleObj;
}

export function formatArticles(articles) {
  return articles
    .filter((article) => article.title)
    .map((article) => formatArticle(article));
}

export function renderValue(input, fallback) {
  return typeof input !== undefined ? input : fallback;
}

export function formatArticleSeo(
  seo,
  articleTitle,
  articleDescription,
  articleImage
) {
  if (!seo) {
    return {
      title: articleTitle,
      description: articleDescription,
      image: { sourceUrl: articleImage },
      ogType: "article",
    };
  }

  //From WP
  const DEFAULT_TITLE = "Indeed Design";
  const DEFAULT_DESCRIPTION =
    "Learn about Indeed’s brand identity and get inspired by stories from the greater design community.";

  const seoObj = {
    canonicalUrl: seo.seoCanonicalUrl || "",
    customFields: seo.seoCustomFields || "",
    description:
      seo.seoDescription !== DEFAULT_DESCRIPTION
        ? seo.seoDescription
        : articleDescription,
    image: { sourceUrl: seo.seoImage?.sourceUrl || articleImage },
    ogDescription: seo.seoOgDescription || "",
    ogTitle: seo.seoOgTitle || "",
    ogType: "article",
    title: seo.seoTitle !== DEFAULT_TITLE ? seo.seoTitle : articleTitle,
  };

  return seoObj;
}
